module.exports = {
      id: "clipboard-usage",
      viewBox: "0 0 44 44",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#clipboard",
      toString: function () {
        return this.url;
      }
    }